export function parseTimeInput(raw: string): number | null {
	const trimmed = raw.trim().toLowerCase();
	if (!trimmed) return null;

	let value: number;

	if (trimmed.endsWith('h')) {
		value = parseFloat(trimmed.slice(0, -1));
	} else if (trimmed.endsWith('m')) {
		const minutes = parseFloat(trimmed.slice(0, -1));
		if (isNaN(minutes) || minutes <= 0) return null;
		value = minutes / 60;
	} else {
		value = parseFloat(trimmed);
	}

	if (isNaN(value) || value <= 0) return null;
	return Math.round(value * 100) / 100;
}
